import React from 'react';
import SplitActionButton from '../common/SplitActionButton';
import type { TaskDismissDuration } from '../../api/dashboard';

export default function HomeTaskDismissButton({ disabled, onDismiss }: {
  disabled: boolean;
  onDismiss: (duration: TaskDismissDuration) => void;
}) {
  return (
    <SplitActionButton
      label="Dismiss"
      title="Remove from your Home page without completing the task"
      onClick={() => onDismiss('forever')}
      disabled={disabled}
      size="xs"
      className="subtle"
      menuLabel="Dismiss task temporarily"
      menuAlign="right"
      items={[
        { label: 'Dismiss for 1 day', onSelect: () => onDismiss('day') },
        { label: 'Dismiss for 1 week', onSelect: () => onDismiss('week') },
        { label: 'Dismiss for 1 month', onSelect: () => onDismiss('month') },
      ]}
    />
  );
}
